import type React from 'react';
import { TextInput } from '@/components/atoms/primitives/TextInput';
import { classNames } from '@/lib/utils';
import type { FormFieldProps } from './FormField.types';

export const FormField: React.FC<FormFieldProps> = ({ error, helperText, className = '', ...inputProps }) => {
  return (
    <div className={classNames('flex flex-col gap-2', className)}>
      <TextInput {...inputProps} error={error} />
      {helperText && !error && <div className="text-xs text-gray-400">{helperText}</div>}
    </div>
  );
};
